import { validDateString } from '../isDateValid/isDateValid';

export const isMonthAndYearFormat = (dateString: string) =>
  validDateString(dateString) && dateString.split('-').length < 3;
